module.exports = __webpack_public_path__ + "img/tower_cantilever_communication.4ac4af14.svg";